var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _path5, _rect9, _rect10, _rect11, _rect12, _rect13, _path6, _rect14, _path7, _path8, _rect15, _rect16, _rect17, _path9, _path10, _path11, _path12, _path13, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path14, _path15, _path16, _g, _rect24, _path17, _path18, _path19, _rect25, _rect26, _path20, _rect27, _g2, _g3, _rect28, _g4, _g5, _rect29, _g6, _g7, _rect30, _g8, _g9, _path21, _g10, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g11, _g12, _path30, _path31, _path32, _path33, _path34, _path35, _g13, _path36, _g14, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g15, _path46, _path47, _path48, _path49, _g16, _path50, _path51, _path52, _path53, _path54, _path55, _g17, _path56, _path57, _path58, _path59, _g18, _g19, _path60, _path61, _path62, _path63, _path64, _path65;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAwaitingDocuments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AWAITING_DOCUMENTS",
    "data-name": "AWAITING DOCUMENTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 372.56,
    viewBox: "0 0 500 372.56",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9329",
    "data-name": "Ret\\xE2ngulo 9329",
    width: 500,
    height: 372.56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9297",
    "data-name": "Ret\\xE2ngulo 9297",
    width: 136.55,
    height: 18.26,
    transform: "translate(286.6 21.1)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9303",
    "data-name": "Ret\\xE2ngulo 9303",
    width: 68.861,
    height: 85.203,
    transform: "translate(85.334 135.115)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9304",
    "data-name": "Ret\\xE2ngulo 9304",
    width: 46.602,
    height: 61.82,
    transform: "translate(95.304 147.124)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9307",
    "data-name": "Ret\\xE2ngulo 9307",
    width: 64.869,
    height: 82.667,
    transform: "translate(161.763 120.77)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9308",
    "data-name": "Ret\\xE2ngulo 9308",
    width: 44.682,
    height: 60.291,
    transform: "translate(171.054 132.264)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9311",
    "data-name": "Ret\\xE2ngulo 9311",
    width: 61.47,
    height: 80.396,
    transform: "translate(109.959 131.742)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9312",
    "data-name": "Ret\\xE2ngulo 9312",
    width: 43.055,
    height: 58.963,
    transform: "translate(118.661 142.76)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9315",
    "data-name": "Ret\\xE2ngulo 9315",
    width: 58.681,
    height: 78.465,
    transform: "translate(176.689 128.068)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9316",
    "data-name": "Ret\\xE2ngulo 9316",
    width: 41.666,
    height: 57.736,
    transform: "translate(184.927 138.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9317",
    "data-name": "Ret\\xE2ngulo 9317",
    width: 188.51,
    height: 137.864,
    transform: "translate(79.93 177.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9318",
    "data-name": "Ret\\xE2ngulo 9318",
    width: 13.55,
    height: 11.37,
    transform: "translate(345.62 333.44)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9319",
    "data-name": "Ret\\xE2ngulo 9319",
    width: 13.63,
    height: 13.93,
    transform: "translate(398.04 308.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9320",
    "data-name": "Ret\\xE2ngulo 9320",
    width: 3.659,
    height: 3.61,
    transform: "translate(332.995 122.56)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9321",
    "data-name": "Ret\\xE2ngulo 9321",
    width: 6.19,
    height: 8.42,
    transform: "translate(335.1 100.9)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9322",
    "data-name": "Ret\\xE2ngulo 9322",
    width: 10.956,
    height: 55.39,
    transform: "translate(336.044 184.18)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9323",
    "data-name": "Ret\\xE2ngulo 9323",
    width: 39.527,
    height: 7.121,
    transform: "translate(324.054 167.819)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9325",
    "data-name": "Ret\\xE2ngulo 9325",
    width: 56.6,
    height: 75.74,
    transform: "translate(282.35 131.26)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9326",
    "data-name": "Ret\\xE2ngulo 9326",
    width: 35.905,
    height: 10.936,
    transform: "translate(293.843 150.092)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9327",
    "data-name": "Ret\\xE2ngulo 9327",
    width: 27.624,
    height: 10.176,
    transform: "translate(292.752 162.202)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13586",
    "data-name": "Grupo 13586",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9273",
    "data-name": "Ret\\xE2ngulo 9273",
    width: 500,
    height: 0.25,
    transform: "translate(0 327.4)",
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9274",
    "data-name": "Ret\\xE2ngulo 9274",
    width: 33.12,
    height: 0.25,
    transform: "translate(416.78 343.49)",
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9275",
    "data-name": "Ret\\xE2ngulo 9275",
    width: 12.89,
    height: 0.25,
    transform: "translate(260.33 340.36)",
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9276",
    "data-name": "Ret\\xE2ngulo 9276",
    width: 27.139,
    height: 0.25,
    transform: "translate(322.53 341.42)",
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9277",
    "data-name": "Ret\\xE2ngulo 9277",
    width: 56.111,
    height: 0.25,
    transform: "translate(359.67 334.21)",
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9278",
    "data-name": "Ret\\xE2ngulo 9278",
    width: 26.53,
    height: 0.25,
    transform: "translate(52.46 345.78)",
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9279",
    "data-name": "Ret\\xE2ngulo 9279",
    width: 22.999,
    height: 0.25,
    transform: "translate(87.89 345.78)",
    fill: "#ebebeb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9280",
    "data-name": "Ret\\xE2ngulo 9280",
    width: 60.809,
    height: 0.25,
    transform: "translate(131 340.24)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13585",
    "data-name": "Grupo 13585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13584",
    "data-name": "Grupo 13584",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7557",
    "data-name": "Caminho 7557",
    d: "M237,282.8H43.91a5.71,5.71,0,0,1-5.7-5.71V5.66A5.71,5.71,0,0,1,43.91,0H237a5.709,5.709,0,0,1,5.71,5.71V277.09A5.709,5.709,0,0,1,237,282.8M43.91.2a5.459,5.459,0,0,0-5.45,5.46V277.09a5.46,5.46,0,0,0,5.45,5.46H237a5.471,5.471,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,237,.2Z",
    fill: "#ebebeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7558",
    "data-name": "Caminho 7558",
    d: "M453.31,282.8H260.21a5.721,5.721,0,0,1-5.71-5.71V5.66A5.72,5.72,0,0,1,260.21,0h193.1A5.71,5.71,0,0,1,459,5.66V277.09a5.71,5.71,0,0,1-5.69,5.71M260.21.2a5.47,5.47,0,0,0-5.46,5.46V277.09a5.471,5.471,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V5.66A5.47,5.47,0,0,0,453.31.2Z",
    fill: "#ebebeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7559",
    "data-name": "Caminho 7559",
    d: "M264.9,241.39c-2-5.75-17.79,2.07-24.2,11.6-4.27,6.34-6.88,13.12-8.09,22.22.14-10.38.31-21.54.47-32.07,1.3-2.62,4.26-8.67,6.38-13.47,7.11-16,24-22,29.83-32.06,7.65-13.24,7.6-33.09,1.1-40.26-5.66-6.22-24.39,35.88-26.5,40.58a124.985,124.985,0,0,0-10.73,39.82c.16-9.89.31-19,.43-26,.4-22.85.89-30.2,1.12-32.46.78-1.1,1.7-2.39,2.24-3.08,4.53-5.83,14.59-12.78,19.61-21.26,7.34-12.39,6.16-27.21,1-32.73-5.38-5.77-14.9,7.87-19.95,21.38s-2.89,26.45-4.31,37.68c-.29,2.2-.6,10.56-.88,22.16-1.54-12.48-4.59-20.84-10.25-28.63-7-9.58-13-21.25-18.69-19.74s-2.65,16.94,1.89,27.78c4,9.66,24,19.28,26.9,27.05-.35,15.72-.66,35.64-.88,54.18-1.57-9.58-.49-10.38-6.93-25.05-3.82-8.72-19.51-19.47-21.38-13.48s1,17.31,6.89,25.24c4.78,6.4,15.38,6.39,17.83,10.36.58.93,2.47,4.48,3.55,6.52-.26,22.64-.37,42.63-.24,49.44l1,.07c0-1.76.08-13.28.28-28.52,2.58-8.11,19.91-12.84,25.26-21.28,5.63-8.79,9.66-19.09,7.25-25.99",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7560",
    "data-name": "Caminho 7560",
    d: "M248.61,327.4H215.35a3.82,3.82,0,0,1-3.75-3.06l-2.36-11.64h45.48l-2.37,11.64a3.811,3.811,0,0,1-3.74,3.06",
    fill: "#f0f0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7561",
    "data-name": "Caminho 7561",
    d: "M255.67,317.21H208.29a2.23,2.23,0,0,1-2.22-2l-1-8.61a2.241,2.241,0,0,1,2.22-2.48h49.32a2.229,2.229,0,0,1,2.224,2.236,2.2,2.2,0,0,1-.014.244l-1,8.61a2.22,2.22,0,0,1-2.15,2",
    fill: "#f0f0f0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9281",
    "data-name": "Ret\\xE2ngulo 9281",
    width: 31.85,
    height: 135.91,
    transform: "translate(400.77 187.32)",
    fill: "#f0f0f0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9282",
    "data-name": "Ret\\xE2ngulo 9282",
    width: 165.02,
    height: 4.17,
    transform: "translate(265.45 323.23)",
    fill: "#f0f0f0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9283",
    "data-name": "Ret\\xE2ngulo 9283",
    width: 137.45,
    height: 135.91,
    transform: "translate(263.31 187.32)",
    fill: "#f5f5f5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9284",
    "data-name": "Ret\\xE2ngulo 9284",
    width: 112.41,
    height: 28.78,
    transform: "translate(275.83 240.89)",
    fill: "#f0f0f0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9285",
    "data-name": "Ret\\xE2ngulo 9285",
    width: 112.41,
    height: 28.78,
    transform: "translate(275.83 277.93)",
    fill: "#f0f0f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7562",
    "data-name": "Caminho 7562",
    d: "M344.65,245.85H319.42a3.105,3.105,0,1,1,0-6.21h25.23a3.105,3.105,0,1,1,0,6.21",
    fill: "#f5f5f5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9286",
    "data-name": "Ret\\xE2ngulo 9286",
    width: 112.41,
    height: 28.78,
    transform: "translate(275.83 203.85)",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7563",
    "data-name": "Caminho 7563",
    d: "M319.42,208.81h25.23a3.1,3.1,0,1,0,0-6.21H319.42a3.1,3.1,0,1,0,0,6.21",
    fill: "#f5f5f5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7564",
    "data-name": "Caminho 7564",
    d: "M319.42,282.89h25.23a3.105,3.105,0,1,0,0-6.21H319.42a3.105,3.105,0,1,0,0,6.21",
    fill: "#f5f5f5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9287",
    "data-name": "Ret\\xE2ngulo 9287",
    width: 140.28,
    height: 3.88,
    transform: "translate(260.48 183.44)",
    fill: "#f0f0f0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9288",
    "data-name": "Ret\\xE2ngulo 9288",
    width: 34.88,
    height: 3.88,
    transform: "translate(400.76 183.45)",
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9289",
    "data-name": "Ret\\xE2ngulo 9289",
    width: 31.47,
    height: 203.53,
    transform: "translate(147.41 123.87)",
    fill: "#e0e0e0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7565",
    "data-name": "Caminho 7565",
    d: "M67.21,327.4H172.58L183.65,76.88H78.28Z",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7566",
    "data-name": "Caminho 7566",
    d: "M51.84,327.4H168.4L179.46,76.88H62.91Z",
    fill: "#f0f0f0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7567",
    "data-name": "Caminho 7567",
    d: "M156.99,315.12l9.32-225.95H74.32L64.99,315.12Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7568",
    "data-name": "Caminho 7568",
    d: "M117.46,315.12,148.73,89.17h-9.81L107.65,315.12Z",
    fill: "#fafafa"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7569",
    "data-name": "Caminho 7569",
    d: "M103.49,315.12,134.76,89.17H118.03L86.76,315.12Z",
    fill: "#fafafa"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9290",
    "data-name": "Ret\\xE2ngulo 9290",
    width: 127.53,
    height: 119.3,
    transform: "translate(293.47 25.82)",
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9291",
    "data-name": "Ret\\xE2ngulo 9291",
    width: 129.64,
    height: 119.3,
    transform: "translate(289.5 25.82)",
    fill: "#f5f5f5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9292",
    "data-name": "Ret\\xE2ngulo 9292",
    width: 127.53,
    height: 4.88,
    transform: "translate(293.47 145.12)",
    fill: "#e6e6e6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9293",
    "data-name": "Ret\\xE2ngulo 9293",
    width: 120.98,
    height: 4.88,
    transform: "translate(285.96 145.12)",
    fill: "#f5f5f5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9294",
    "data-name": "Ret\\xE2ngulo 9294",
    width: 118.56,
    height: 104.51,
    transform: "translate(295.04 33.21)",
    fill: "#fafafa"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9295",
    "data-name": "Ret\\xE2ngulo 9295",
    width: 0.79,
    height: 104.51,
    transform: "translate(295.05 33.22)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7570",
    "data-name": "Caminho 7570",
    d: "M393.94,137.72,373.44,33.21H346.57l20.5,104.51Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7571",
    "data-name": "Caminho 7571",
    d: "M362.72,137.72,342.22,33.21H330.09l20.5,104.51Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7572",
    "data-name": "Caminho 7572",
    d: "M409.64,21.72V132.06a.61.61,0,0,1-.61.61h-.05a.61.61,0,0,1-.61-.61V21.72a.61.61,0,0,1,.61-.61h.05a.61.61,0,0,1,.61.61",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13526",
    "data-name": "Grupo 13526",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13525",
    "data-name": "Grupo 13525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13524",
    "data-name": "Grupo 13524",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9296",
    "data-name": "Ret\\xE2ngulo 9296",
    width: 136.55,
    height: 18.26,
    transform: "translate(286.6 21.1)",
    fill: "#e6e6e6"
  }))))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9298",
    "data-name": "Ret\\xE2ngulo 9298",
    width: 136.55,
    height: 2.27,
    transform: "translate(286.6 21.1)",
    fill: "#e0e0e0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7573",
    "data-name": "Caminho 7573",
    d: "M422.93,22.1H286.83a.87.87,0,0,1-.87-.87v-.25a.87.87,0,0,1,.87-.87h136.1a.871.871,0,0,1,.87.87v.25a.871.871,0,0,1-.87.87",
    fill: "#ebebeb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7574",
    "data-name": "Caminho 7574",
    d: "M286.43,39.84H423.32a.469.469,0,0,0,.47-.47v-.01a.469.469,0,0,0-.47-.47H286.43a.475.475,0,1,0,0,.95",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7575",
    "data-name": "Caminho 7575",
    d: "M250,349.92c107.082,0,193.89,5.068,193.89,11.32S357.082,372.56,250,372.56,56.11,367.492,56.11,361.24,142.918,349.92,250,349.92",
    fill: "#f5f5f5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9299",
    "data-name": "Ret\\xE2ngulo 9299",
    width: 1.02,
    height: 15.5,
    transform: "matrix(0.993, -0.116, 0.116, 0.993, 63.829, 217.2)",
    fill: "#0096a2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9300",
    "data-name": "Ret\\xE2ngulo 9300",
    width: 1.02,
    height: 7.82,
    transform: "translate(66.299 238.321) rotate(-6.644)",
    fill: "#0096a2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7576",
    "data-name": "Caminho 7576",
    d: "M134.59,185.69l-1.2-3.37a10.861,10.861,0,0,0-11.5-7.14L74.1,180.77a10.869,10.869,0,0,0-9.53,12.06l13.6,116.3a7.449,7.449,0,0,0,8.259,6.541h.011l171-20A7.45,7.45,0,0,0,264,287.428l0-.028L252.2,186.86a7.45,7.45,0,0,0-8.26-6.54l-99.3,11.62a9.51,9.51,0,0,1-10.05-6.25",
    fill: "#0096a2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9301",
    "data-name": "Ret\\xE2ngulo 9301",
    width: 55.09,
    height: 75.9,
    transform: "matrix(0.981, -0.195, 0.195, 0.981, 85.334, 145.882)",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13529",
    "data-name": "Grupo 13529",
    opacity: 0.7,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13528",
    "data-name": "Grupo 13528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13527",
    "data-name": "Grupo 13527",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9302",
    "data-name": "Ret\\xE2ngulo 9302",
    width: 55.09,
    height: 75.9,
    transform: "matrix(0.981, -0.195, 0.195, 0.981, 85.334, 145.882)",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13532",
    "data-name": "Grupo 13532",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13531",
    "data-name": "Grupo 13531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13530",
    "data-name": "Grupo 13530",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7577",
    "data-name": "Caminho 7577",
    d: "M132.15,153l-33.28,6.64a2.983,2.983,0,0,1-1.17-5.85l33.3-6.61a2.966,2.966,0,1,1,1.15,5.82",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7578",
    "data-name": "Caminho 7578",
    d: "M134.6,165.33,101.32,172a2.977,2.977,0,1,1-1.16-5.84l33.28-6.63a2.957,2.957,0,1,1,1.16,5.8",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7579",
    "data-name": "Caminho 7579",
    d: "M137.05,177.64l-33.28,6.63a2.977,2.977,0,0,1-1.16-5.84l33.28-6.64a2.982,2.982,0,0,1,1.16,5.85",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7580",
    "data-name": "Caminho 7580",
    d: "M139.51,190l-33.28,6.63a2.983,2.983,0,0,1-1.17-5.85l33.28-6.63a2.983,2.983,0,1,1,1.17,5.85",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7581",
    "data-name": "Caminho 7581",
    d: "M132.86,204.07l-24.18,4.82a2.982,2.982,0,0,1-1.16-5.85l24.18-4.82a2.982,2.982,0,0,1,1.16,5.85",
    fill: "#0096a2"
  }))))), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9305",
    "data-name": "Ret\\xE2ngulo 9305",
    width: 55.09,
    height: 75.9,
    transform: "matrix(0.991, -0.136, 0.136, 0.991, 161.763, 128.237)",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13535",
    "data-name": "Grupo 13535",
    opacity: 0.7,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13534",
    "data-name": "Grupo 13534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13533",
    "data-name": "Grupo 13533",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9306",
    "data-name": "Ret\\xE2ngulo 9306",
    width: 55.09,
    height: 75.9,
    transform: "matrix(0.991, -0.136, 0.136, 0.991, 161.763, 128.237)",
    fill: "#fff"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13538",
    "data-name": "Grupo 13538",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13537",
    "data-name": "Grupo 13537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13536",
    "data-name": "Grupo 13536",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7582",
    "data-name": "Caminho 7582",
    d: "M208.06,138.2l-33.62,4.6a2.983,2.983,0,1,1-.81-5.91l33.62-4.6a2.983,2.983,0,1,1,.81,5.91",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7583",
    "data-name": "Caminho 7583",
    d: "M209.76,150.63l-33.62,4.6a2.978,2.978,0,1,1-.81-5.9l33.62-4.6a2.978,2.978,0,1,1,.81,5.9",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7584",
    "data-name": "Caminho 7584",
    d: "M187.1,166.4l-9.26,1.27a2.983,2.983,0,1,1-.81-5.91l9.27-1.27a2.982,2.982,0,0,1,.8,5.91",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7585",
    "data-name": "Caminho 7585",
    d: "M205.07,163.94l-9.27,1.27a2.982,2.982,0,0,1-.8-5.91l9.26-1.26a2.978,2.978,0,1,1,.81,5.9",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7586",
    "data-name": "Caminho 7586",
    d: "M213.16,175.5l-33.62,4.6a2.978,2.978,0,1,1-.81-5.9l33.62-4.61a2.983,2.983,0,1,1,.81,5.91",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7587",
    "data-name": "Caminho 7587",
    d: "M205.68,189.19l-24.44,3.34a2.978,2.978,0,0,1-.81-5.9l24.44-3.34a2.978,2.978,0,0,1,.81,5.9",
    fill: "#0096a2"
  }))))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9309",
    "data-name": "Ret\\xE2ngulo 9309",
    width: 55.09,
    height: 75.9,
    transform: "translate(109.959 136.524) rotate(-4.98)",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13541",
    "data-name": "Grupo 13541",
    opacity: 0.8,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13540",
    "data-name": "Grupo 13540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13539",
    "data-name": "Grupo 13539",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9310",
    "data-name": "Ret\\xE2ngulo 9310",
    width: 55.09,
    height: 75.9,
    transform: "translate(109.959 136.524) rotate(-4.98)",
    fill: "#fff"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13544",
    "data-name": "Grupo 13544",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13543",
    "data-name": "Grupo 13543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13542",
    "data-name": "Grupo 13542",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7588",
    "data-name": "Caminho 7588",
    d: "M155.71,148.76,121.9,151.7a2.976,2.976,0,1,1-.52-5.93l33.81-3a3.006,3.006,0,0,1,.537,5.988l-.017,0",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7589",
    "data-name": "Caminho 7589",
    d: "M156.8,161.26l-33.81,3a2.981,2.981,0,1,1-.52-5.94l33.81-3a2.981,2.981,0,1,1,.52,5.94",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7590",
    "data-name": "Caminho 7590",
    d: "M157.89,173.76l-33.81,3a2.981,2.981,0,1,1-.52-5.94l33.81-3a2.981,2.981,0,1,1,.52,5.94",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7591",
    "data-name": "Caminho 7591",
    d: "M159,186.26l-33.81,3a2.981,2.981,0,1,1-.52-5.94l33.81-2.94a2.952,2.952,0,1,1,.52,5.88",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7592",
    "data-name": "Caminho 7592",
    d: "M150.83,199.57l-24.57,2.14a2.983,2.983,0,1,1-.55-5.94l24.57-2.14a2.983,2.983,0,0,1,.55,5.94",
    fill: "#0096a2"
  }))))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9313",
    "data-name": "Ret\\xE2ngulo 9313",
    width: 55.09,
    height: 75.9,
    transform: "matrix(0.999, -0.048, 0.048, 0.999, 176.689, 130.721)",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13547",
    "data-name": "Grupo 13547",
    opacity: 0.8,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13546",
    "data-name": "Grupo 13546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13545",
    "data-name": "Grupo 13545",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_9314",
    "data-name": "Ret\\xE2ngulo 9314",
    width: 55.09,
    height: 75.9,
    transform: "matrix(0.999, -0.048, 0.048, 0.999, 176.689, 130.721)",
    fill: "#fff"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13550",
    "data-name": "Grupo 13550",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13549",
    "data-name": "Grupo 13549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13548",
    "data-name": "Grupo 13548",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7593",
    "data-name": "Caminho 7593",
    d: "M221.94,144.7l-33.89,1.64a2.979,2.979,0,1,1-.29-5.95l33.9-1.64a2.978,2.978,0,1,1,.28,5.95",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7594",
    "data-name": "Caminho 7594",
    d: "M222.55,157.24l-33.9,1.63a2.978,2.978,0,1,1-.28-5.95l33.89-1.64a2.984,2.984,0,0,1,.29,5.96",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7595",
    "data-name": "Caminho 7595",
    d: "M198.6,171l-9.34.45a2.979,2.979,0,0,1-.29-5.95l9.34-.46a2.984,2.984,0,0,1,.29,5.96",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7596",
    "data-name": "Caminho 7596",
    d: "M216.71,170.08l-9.34.45a2.979,2.979,0,1,1-.29-5.95l9.34-.45a2.979,2.979,0,0,1,.29,5.95",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7597",
    "data-name": "Caminho 7597",
    d: "M223.76,182.31l-33.9,1.63a2.978,2.978,0,1,1-.28-5.95l33.89-1.64a2.984,2.984,0,0,1,.29,5.96",
    fill: "#0096a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7598",
    "data-name": "Caminho 7598",
    d: "M215.1,195.29l-24.63,1.19a2.979,2.979,0,0,1-.29-5.95l24.63-1.19a2.979,2.979,0,0,1,.29,5.95",
    fill: "#0096a2"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7599",
    "data-name": "Caminho 7599",
    d: "M149.85,187.84l-.88-3.29a9.62,9.62,0,0,0-10.71-7l-47.79,5.59A12,12,0,0,0,79.93,195l2.71,113.85a6.568,6.568,0,0,0,7.57,6.38l171-20a8.219,8.219,0,0,0,7.23-8.11L266.1,188.7a6.579,6.579,0,0,0-6.7-6.455,6.46,6.46,0,0,0-.878.075l-99.29,11.61a8.41,8.41,0,0,1-9.38-6.09",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13553",
    "data-name": "Grupo 13553",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13552",
    "data-name": "Grupo 13552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13551",
    "data-name": "Grupo 13551",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7600",
    "data-name": "Caminho 7600",
    d: "M149.85,187.84l-.88-3.29a9.62,9.62,0,0,0-10.71-7l-47.79,5.59A12,12,0,0,0,79.93,195l2.71,113.85a6.568,6.568,0,0,0,7.57,6.38l171-20a8.219,8.219,0,0,0,7.23-8.11L266.1,188.7a6.579,6.579,0,0,0-6.7-6.455,6.46,6.46,0,0,0-.878.075l-99.29,11.61a8.41,8.41,0,0,1-9.38-6.09"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7601",
    "data-name": "Caminho 7601",
    d: "M317,133.11c-.74,3.71-1.53,7.37-2.42,11s-1.76,7.3-2.73,10.93l-1.48,5.43-.19.7c-.09.3-.19.6-.31.91a9.154,9.154,0,0,1-1,1.93,7.014,7.014,0,0,1-1.87,1.9,6,6,0,0,1-2.73,1A7.826,7.826,0,0,1,300,166a15.633,15.633,0,0,1-2.78-1.93,24.225,24.225,0,0,1-4.07-4.59L296,157a34.964,34.964,0,0,0,4.3,2.86,10.441,10.441,0,0,0,2.06.89c.61.2,1.15.17,1.15.07s-.1,0-.15,0,0,0,0-.17a3.352,3.352,0,0,1,.19-.61l.23-1.11,1.16-5.46,2.35-10.92c.76-3.64,1.58-7.29,2.37-10.89Z",
    fill: "#1ed6bb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7602",
    "data-name": "Caminho 7602",
    d: "M313.68,121.68c-8.53,6.53-8.18,18.84-8.18,18.84l15.25,3.65s4.69-12.38,2.79-16.91c-1.98-4.72-5.05-9.26-9.86-5.58",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7603",
    "data-name": "Caminho 7603",
    d: "M296.76,157.15l-5.61-5.61-3,8.78s4.74,2.55,9.27.14Z",
    fill: "#1ed6bb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7604",
    "data-name": "Caminho 7604",
    d: "M283.38,150.67l-1.03,6.94,5.77,2.71,3.03-8.78Z",
    fill: "#1ed6bb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7605",
    "data-name": "Caminho 7605",
    d: "M363.12,353.86l-8.58.84-8.93-20.43,8.58-.84Z",
    fill: "#1ed6bb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7606",
    "data-name": "Caminho 7606",
    d: "M418.4,323.66l-6.45,6.05-13.91-15.29,6.45-6.05Z",
    fill: "#1ed6bb"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7607",
    "data-name": "Caminho 7607",
    d: "M409,326.81l4.84-8.72a.71.71,0,0,1,.88-.33l7.45,2.84a1.425,1.425,0,0,1,.69,2c-1.74,3-2.73,4.38-4.86,8.22-1.31,2.36-3.86,7.77-5.67,11s-5.13,1.65-4.67.13c2.07-6.82,1.68-10.61,1.1-13.61a2.3,2.3,0,0,1,.24-1.53",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7608",
    "data-name": "Caminho 7608",
    d: "M353.4,352.05h10.54a.86.86,0,0,1,.83.64l2.29,8.33a1.31,1.31,0,0,1-.9,1.62,1.327,1.327,0,0,1-.381.05H341.51c-3.86,0-4.66-3.89-3.07-4.25,7.15-1.58,11.26-3.76,13.47-5.84a2.179,2.179,0,0,1,1.49-.55",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13556",
    "data-name": "Grupo 13556",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13555",
    "data-name": "Grupo 13555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13554",
    "data-name": "Grupo 13554",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7609",
    "data-name": "Caminho 7609",
    d: "M345.62,334.28l4.6,10.53h8.95l-4.97-11.37Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13559",
    "data-name": "Grupo 13559",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13558",
    "data-name": "Grupo 13558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13557",
    "data-name": "Grupo 13557",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7610",
    "data-name": "Caminho 7610",
    d: "M404.49,308.38l-6.45,6.05,7.18,7.88,6.45-6.06Z"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7611",
    "data-name": "Caminho 7611",
    d: "M316.26,120.42s-3.86,1.69,9.08,52.89l35.94-3.11c-1.86-14.57-2.66-23.59,1.73-54.22a105.784,105.784,0,0,0-15.43-.69,115.129,115.129,0,0,0-16.32,1.41,152.208,152.208,0,0,0-15,3.72",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7612",
    "data-name": "Caminho 7612",
    d: "M347.58,115h4.44c1.45,2.23-3.25,12-11,18.39a19.7,19.7,0,0,0-6.25-9.06Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7613",
    "data-name": "Caminho 7613",
    d: "M331.26,116.57s-.91.13-3.08.63c-1.45,2.23-3.9,11.76.37,16.62a19.177,19.177,0,0,1,6.19-9.41Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7614",
    "data-name": "Caminho 7614",
    d: "M344.37,97.05c-.57,5.34-.77,15,3.21,18.24,0,0-4.25,4.34-12.84,9.12-6.25-4.32-3.48-7.71-3.48-7.71,5.73-1.9,5.2-6.23,3.83-10.23Z",
    fill: "#1ed6bb"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7615",
    "data-name": "Caminho 7615",
    d: "M334.59,124.44s5.27-5.74,8-4.64.62,3.07.38,4.92,1.06,6.77-2.59,5.49-5.79-5.77-5.79-5.77",
    fill: "#0096a2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7616",
    "data-name": "Caminho 7616",
    d: "M334.38,124.32s-2.49-4.4-5.18-3.81-1.09,2.13-.85,3.79c.31,2.12-1.93,6.2,1.31,5s4.72-4.98,4.72-4.98",
    fill: "#0096a2"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13562",
    "data-name": "Grupo 13562",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13561",
    "data-name": "Grupo 13561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13560",
    "data-name": "Grupo 13560",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7617",
    "data-name": "Caminho 7617",
    d: "M333,123.37a5.712,5.712,0,0,0,.5,2.58,12.015,12.015,0,0,0,.87-1.62,12.079,12.079,0,0,0-1.27-1.77,2.268,2.268,0,0,0-.1.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7618",
    "data-name": "Caminho 7618",
    d: "M336.51,122.58c-1.13,1-1.91,1.86-1.91,1.86a13.7,13.7,0,0,0,1,1.73,3.438,3.438,0,0,0,1-2.27,2.366,2.366,0,0,0-.09-1.32"
  }))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7619",
    "data-name": "Caminho 7619",
    d: "M334.53,126.24c-.75,0-1.21-.81-1.26-2.74s1.43-.86,1.43-.86,2-1,1.64,1.31c-.26,1.83-1.04,2.29-1.81,2.29",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13565",
    "data-name": "Grupo 13565",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13564",
    "data-name": "Grupo 13564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13563",
    "data-name": "Grupo 13563",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7620",
    "data-name": "Caminho 7620",
    d: "M340.59,100.9l-5.49,5.57a17.638,17.638,0,0,1,.75,2.85c2.21-.51,5.41-2.81,5.44-5.17a9.283,9.283,0,0,0-.7-3.25"
  }))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7621",
    "data-name": "Caminho 7621",
    d: "M335.88,79s-6,8.31-7,12c-4.08,2.38-4.9-9.33-2.74-16.55,6.74,4.23,9.74,4.55,9.74,4.55",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7622",
    "data-name": "Caminho 7622",
    d: "M349.07,88.71c-2.23,8.53-3,12.19-8.22,15.76-7.87,5.38-17.86.78-18.23-8.25-.33-8.12,3.37-20.71,12.5-22.48a12,12,0,0,1,13.95,14.97",
    fill: "#1ed6bb"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7623",
    "data-name": "Caminho 7623",
    d: "M353.71,85.3s-4.29,6.95-4.87,10c-3.11,2.11-4.42-7.15-3.11-13,1.43-5.21,7.98,3,7.98,3",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7624",
    "data-name": "Caminho 7624",
    d: "M352,80.47c-1.24.94-2.55-2.53-1.32-5.19-2.37.15-5.22-1.26-4.61-3.55-4.67,1.57-6.4-3.18-5.86-6.47.65-4,4.13-4.85,6.18-3.8,0-1.79,4.52-5.52,6.24-2.6,3.19-1.13,8.33-.78,8.22,3.14,2.11.06,8.34,2.45,6,8,2.75.16,4.24,3.65,2.71,6.29a4.251,4.251,0,0,1,.87,6.9c1.27,2.64-2.58,6.57-4.63,6.1-1.56,2.39-3.95,4.19-5.51,2.15-3,2.21-6.45-.6-5.68-2.76-3.4-.52-6.87-6.19-2.61-8.21",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7625",
    "data-name": "Caminho 7625",
    d: "M357.08,72.07c2.24,3.74,2.05,8-.41,9.45s-6.29-.35-8.53-4.09-2.06-8,.41-9.45,6.29.36,8.53,4.09",
    fill: "#0096a2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7626",
    "data-name": "Caminho 7626",
    d: "M336.28,78c-.13,1.07-3.08.79-3.93-1.1-1.22,1.28-4.09,1.94-5.07.55-1.66,3.12-5,2.3-5.86.81s-1.43-4.26.3-4.81c-1-.86-.7-4.91,1.92-4.4,1.1-2.16,4.11-4.61,6.31-2.7,1.2-1,6-3.08,7.94.73a3.41,3.41,0,0,1,5.11,1.6c3.11-.81,4.46,1.55,4.45,2.83,2.21.6,2.36,4.42,1,5.24.53,1.93.25,4-1.78,3.82-.39,2.6-3.87,3-4.69,1.59-2.26,1.45-6.87-1.07-5.7-4.16",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7627",
    "data-name": "Caminho 7627",
    d: "M331,70.62c2.53-3.5,11.76-5,19.75.29,7.2,4.73,6.73,15.72,1,15.13s-11.39-7.3-11.39-7.3Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7628",
    "data-name": "Caminho 7628",
    d: "M349.77,96.41a6.46,6.46,0,0,1-3.78,3.14c-2.17.65-3.29-1.27-2.73-3.34.51-1.86,2.24-4.44,4.43-4.18a2.89,2.89,0,0,1,2.08,4.38",
    fill: "#1ed6bb"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7629",
    "data-name": "Caminho 7629",
    d: "M325.34,173.31s-12.16,53.8-4,91.73c5.44,25.4,25,76.71,25,76.71l15.34-.39s-14.85-53.85-17.92-75c-5.25-36.22,7.9-95.29,7.9-95.29Z",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13568",
    "data-name": "Grupo 13568",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13567",
    "data-name": "Grupo 13567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13566",
    "data-name": "Grupo 13566",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7630",
    "data-name": "Caminho 7630",
    d: "M339.36,184.18,347,196.27a370.921,370.921,0,0,0-4.39,43.3c-10.75-19.3-5.61-45.18-3.25-55.39"
  }))))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7631",
    "data-name": "Caminho 7631",
    d: "M344.18,342.55l18.94-.49-1.09-5.81-19.33.91Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7632",
    "data-name": "Caminho 7632",
    d: "M333.2,172.74s7.13,57.05,22.6,88.2c12.49,25.16,45.82,61,45.82,61l8.52-8.78s-22.51-38.92-31.79-55.63c-22.77-41-4.16-72.25-17.07-87.3Z",
    fill: "#0096a2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7633",
    "data-name": "Caminho 7633",
    d: "M400.76,323.09l11-10.72-3.65-4.97-11.67,11.64Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7634",
    "data-name": "Caminho 7634",
    d: "M361.64,168.05l1.9,3.08c.15.23-.13.51-.54.55l-37.7,3.26c-.32,0-.6-.11-.64-.31l-.6-3.19c-.05-.22.22-.43.57-.46l36.4-3.15a.638.638,0,0,1,.61.22",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13571",
    "data-name": "Grupo 13571",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13570",
    "data-name": "Grupo 13570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13569",
    "data-name": "Grupo 13569",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7635",
    "data-name": "Caminho 7635",
    d: "M361.64,168.05l1.9,3.08c.15.23-.13.51-.54.55l-37.7,3.26c-.32,0-.6-.11-.64-.31l-.6-3.19c-.05-.22.22-.43.57-.46l36.4-3.15a.638.638,0,0,1,.61.22",
    fill: "#fff"
  }))))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7636",
    "data-name": "Caminho 7636",
    d: "M357.1,172.54l1-.08c.19,0,.33-.13.31-.25l-.82-4.14c0-.13-.2-.21-.4-.19l-1,.08c-.2,0-.34.13-.31.25l.82,4.14c.03.12.21.21.4.19",
    fill: "#0096a2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7637",
    "data-name": "Caminho 7637",
    d: "M328.07,175.05l1-.08c.19,0,.33-.13.31-.25l-.82-4.14a.359.359,0,0,0-.4-.19l-1,.08c-.2,0-.34.13-.31.25l.82,4.14c.03.14.21.21.4.19",
    fill: "#0096a2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7638",
    "data-name": "Caminho 7638",
    d: "M342.59,173.8l1-.09c.2,0,.34-.13.31-.25l-.82-4.14c0-.12-.2-.21-.39-.19l-1,.09c-.19,0-.33.13-.31.25l.82,4.14c.02.12.19.2.39.19",
    fill: "#0096a2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7646",
    "data-name": "Caminho 7646",
    d: "M364.54,124.16c.68.66,1.15,1.18,1.68,1.77s1,1.17,1.48,1.76c.95,1.19,1.86,2.41,2.71,3.66a60.273,60.273,0,0,1,4.48,7.91,51.293,51.293,0,0,1,3.11,8.57c.39,1.47.74,3,1,4.47a9.579,9.579,0,0,1-.69,6.32,8.363,8.363,0,0,1-2.23,2.66,11.288,11.288,0,0,1-2.61,1.5,18.9,18.9,0,0,1-5,1.18,41.974,41.974,0,0,1-9.13-.12,93.75,93.75,0,0,1-17.1-3.63l.92-3.63c2.72.45,5.52.87,8.28,1.16s5.54.55,8.27.61a43.337,43.337,0,0,0,7.91-.44,12.536,12.536,0,0,0,3.26-1,2.751,2.751,0,0,0,1.47-1.31,1.988,1.988,0,0,0,.12-.72,3.475,3.475,0,0,0,0-.54,3.619,3.619,0,0,0-.16-.75c-.28-1.29-.65-2.56-1.05-3.82a52.4,52.4,0,0,0-3-7.32,53.586,53.586,0,0,0-4.08-6.83c-.75-1.1-1.54-2.17-2.36-3.2-.41-.52-.84-1-1.26-1.51s-.9-1-1.23-1.36Z",
    fill: "#1ed6bb"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7647",
    "data-name": "Caminho 7647",
    d: "M345.45,157.13l-7-3.71-.32,9.27s5,.32,7.86-2Z",
    fill: "#1ed6bb"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7648",
    "data-name": "Caminho 7648",
    d: "M333.17,207l5.78-62.81-12.35-9.46-37.7-3.47-6.55,71.06Z",
    fill: "#0096a2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13577",
    "data-name": "Grupo 13577",
    opacity: 0.8,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13576",
    "data-name": "Grupo 13576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13575",
    "data-name": "Grupo 13575",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7649",
    "data-name": "Caminho 7649",
    d: "M333.17,207l5.78-62.81-12.35-9.46-37.7-3.47-6.55,71.06Z",
    fill: "#fff"
  }))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7650",
    "data-name": "Caminho 7650",
    d: "M338.95,144.19l-12.35-9.46,3.24,11.32Z",
    fill: "#0096a2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7651",
    "data-name": "Caminho 7651",
    d: "M286.77,182.5a15.4,15.4,0,1,1-15.4,15.4,15.4,15.4,0,0,1,15.4-15.4",
    fill: "#1ed6bb"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7652",
    "data-name": "Caminho 7652",
    d: "M279.154,188.253A12.28,12.28,0,1,1,277.13,205.5a12.278,12.278,0,0,1,2.024-17.248",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7653",
    "data-name": "Caminho 7653",
    d: "M294.36,196.82l-5.42-.63.63-5.42-3.88-.46-.63,5.42-5.42-.64-.46,3.89,5.42.64-.64,5.41,3.89.46.63-5.42,5.42.64Z",
    fill: "#1ed6bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13580",
    "data-name": "Grupo 13580",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13579",
    "data-name": "Grupo 13579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13578",
    "data-name": "Grupo 13578",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7654",
    "data-name": "Caminho 7654",
    d: "M329.73,157.21h0a4.2,4.2,0,0,1-4.565,3.8h-.005l-27.5-2.53a4.2,4.2,0,0,1,.765-8.37h.005l27.5,2.53a4.2,4.2,0,0,1,3.8,4.565v.005",
    fill: "#0096a2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13583",
    "data-name": "Grupo 13583",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13582",
    "data-name": "Grupo 13582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13581",
    "data-name": "Grupo 13581",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7655",
    "data-name": "Caminho 7655",
    d: "M320.36,168.56h0a4.2,4.2,0,0,1-4.565,3.8h-.005l-19.22-1.77a4.2,4.2,0,0,1-3.8-4.565v0a4.2,4.2,0,0,1,4.565-3.8h.005L316.56,164a4.21,4.21,0,0,1,3.8,4.56",
    fill: "#0096a2"
  }))))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7656",
    "data-name": "Caminho 7656",
    d: "M334.17,153.97l1.05,6.93,2.9,1.79.32-9.27Z",
    fill: "#1ed6bb"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7657",
    "data-name": "Caminho 7657",
    d: "M363,116c4.41.78,10.59,13.42,10.59,13.42l-11.11,10s-8.84-9.64-8.37-15.38c.41-4.85,3.29-9.04,8.89-8.04",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7658",
    "data-name": "Caminho 7658",
    d: "M407.28,331.5a1.352,1.352,0,0,0,.34-.05c1.06-.36,1.75-2.31,2.07-3.44a.189.189,0,0,0-.06-.18.151.151,0,0,0-.19,0c-.32.16-3.14,1.67-3.23,2.78a.65.65,0,0,0,.3.62,1.218,1.218,0,0,0,.77.27m2-3.18c-.49,1.56-1.12,2.59-1.72,2.79a.81.81,0,0,1-.79-.18.319.319,0,0,1-.16-.31c0-.68,1.65-1.75,2.62-2.3Z",
    fill: "#0096a2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7659",
    "data-name": "Caminho 7659",
    d: "M406.84,328.76a6.348,6.348,0,0,0,2.77-.65.18.18,0,0,0,.08-.15.162.162,0,0,0-.09-.15c-.09-.05-2.32-1.28-3.52-.85a1,1,0,0,0-.66.62.7.7,0,0,0,.16.86,2,2,0,0,0,1.26.32m2.29-.8c-.95.41-2.8.66-3.32.22-.09-.08-.18-.2-.06-.47a.679.679,0,0,1,.44-.42c.81-.29,2.31.36,2.94.71Z",
    fill: "#0096a2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7660",
    "data-name": "Caminho 7660",
    d: "M348.73,353.75a13.879,13.879,0,0,0,2.87-.37.17.17,0,0,0,0-.32c-.43-.21-4.26-2-5.22-1.32a.56.56,0,0,0-.25.54,1.252,1.252,0,0,0,.52,1,3.423,3.423,0,0,0,2.08.47m2.27-.6c-1.13.21-3.23.49-4.1-.16a1,1,0,0,1-.38-.73.22.22,0,0,1,.1-.23c.53-.37,2.79.42,4.38,1.12",
    fill: "#0096a2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7661",
    "data-name": "Caminho 7661",
    d: "M351.56,353.39a.2.2,0,0,0,.12,0,.17.17,0,0,0,.05-.18c0-.16-.9-3.93-3-3.69-.52.07-.67.32-.69.53-.13,1,2.28,2.89,3.43,3.37Zm-2.62-3.57c1.33,0,2.1,2.2,2.36,3.08-1.25-.66-3-2.23-2.89-2.84,0-.05,0-.19.39-.23Z",
    fill: "#0096a2"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAwaitingDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/awaitingDocuments.3fb26048cfc9beaa9006435ecbbc1539.svg";